import React, { useState } from "react";

export default function EmojiDailyChallenge({ game }) {
  const [done, setDone] = useState(false);

  const challenge = game.dailyChallenge || {
    task: "Find 20 animals",
    reward: 50,
    progress: 0,
    target: 20,
  };

  const progress = Math.min(
    100,
    Math.floor((challenge.progress / challenge.target) * 100),
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white p-3">
      {/* HEADER */}

      <div className="text-xl font-black text-orange-300">
        🌞 Daily Challenge
      </div>

      <div className="text-xs text-slate-400 mb-4">
        Complete missions to earn XP
      </div>

      {/* CARD */}

      <div className="rounded-2xl bg-slate-900 border border-orange-500/20 p-4">
        <div className="text-lg font-bold">{challenge.task}</div>

        <div className="text-sm text-slate-400 mt-1">
          Reward: ⭐ {challenge.reward} XP
        </div>

        {/* PROGRESS */}

        <div className="mt-4">
          <div className="flex justify-between text-xs mb-1">
            <span>Progress</span>

            <span>{progress}%</span>
          </div>

          <div className="h-3 bg-slate-800 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-orange-400 to-pink-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        {/* BUTTON */}

        <button
          onClick={() => setDone(true)}
          className={`mt-5 w-full py-3 rounded-xl font-black transition

${done ? "bg-green-500 text-black" : "bg-orange-500 text-black"}

`}
        >
          {done ? "Completed 🎉" : "Start Challenge"}
        </button>
      </div>
    </div>
  );
}
